import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If there's a hash (like #contact), scroll to that element. Only plain ids
    // count: auth redirects put tokens in the hash (#access_token=...), which
    // aren't element ids and would make querySelector throw.
    const id = /^#[A-Za-z][\w-]*$/.test(hash) ? hash.slice(1) : "";
    if (id) {
      const element = document.getElementById(id);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth" });
        }, 100);
        return;
      }
    }
    // Otherwise scroll to top
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}
